exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".FreeTextCard_root{margin-left:35px}.FreeTextCard_root>p{font-size:13px;margin-bottom:0px}.FreeTextCard_root textarea{font-size:13px}\n", ""]);

// Exports
exports.locals = {
	"root": "FreeTextCard_root"
};